const formatNumber = (value, numFractionDigits = 0) => {
  const hasDecimal = value % 1 !== 0;
  const numericValue = hasDecimal ? Number.parseFloat(value) : Number.parseInt(value);
  const options = hasDecimal ? { minimumFractionDigits: numFractionDigits } : {};
  return numericValue.toLocaleString('sv-SE', options);
};

export default formatNumber;
